export const supportedTypes = ['csrd', 'issb'] as const;
